let reasonsWrapper = $('#reasonsWrapper');

function moveStickyCTA() {
  const reasons = document.querySelector('#reasons');

  if (reasons.dataset.sticky !== undefined) {
    const stickyCTA = document.querySelector('#stickyCTA');
    const position = document.querySelectorAll('.reason');

    position[reasons.dataset.sticky - 1].after(stickyCTA)
  }
}

moveStickyCTA();